import React from "react";
import Modal from "./Modal";
import Button from "@/components/Button";

export default function ConfirmStatusModal({ school, newStatus, onCancel, onConfirm }) {
  const isApprove = newStatus === "approved";
  return (
    <Modal onClose={onCancel} size="sm" testid="confirm-status-modal">
      <h3 className="text-lg font-black text-sprouts-text">
        {isApprove ? "Approve" : "Reject"} {school.school_name}?
      </h3>
      <p className="text-sm text-sprouts-muted mt-2 leading-relaxed">
        {isApprove
          ? `An approval email with the student submission link will be sent to ${school.coordinator_email}.`
          : `A polite "thanks but unable to approve" email will be sent to ${school.coordinator_email}.`}
      </p>
      <div className="mt-5 flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          data-testid="confirm-cancel"
          className="px-4 py-2.5 rounded-full text-sm font-bold text-sprouts-muted hover:bg-slate-100"
        >
          Cancel
        </button>
        <Button variant={isApprove ? "primary" : "secondary"} onClick={onConfirm} data-testid="confirm-do-action">
          {isApprove ? "Approve & email" : "Reject & email"}
        </Button>
      </div>
    </Modal>
  );
}

export function ConfirmDeleteModal({ school, onCancel, onConfirm, loading }) {
  return (
    <Modal onClose={onCancel} size="sm" testid="confirm-delete-modal">
      <h3 className="text-lg font-black text-sprouts-text">Delete {school.school_name}?</h3>
      <p className="text-sm text-sprouts-muted mt-2 leading-relaxed">
        This permanently removes the school and its registration record from the database. This cannot be undone.
        Any student entries already submitted will remain but will reference an inactive school.
      </p>
      <div className="mt-5 flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          data-testid="confirm-delete-cancel"
          className="px-4 py-2.5 rounded-full text-sm font-bold text-sprouts-muted hover:bg-slate-100"
        >
          Cancel
        </button>
        <Button variant="danger" onClick={onConfirm} loading={loading} data-testid="confirm-delete-do">
          {loading ? "Deleting..." : "Delete permanently"}
        </Button>
      </div>
    </Modal>
  );
}
